import React, { useEffect, useState } from 'react';
import axios from 'axios'
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx'; 
import 'react-tabs/style/react-tabs.css';  
import { toast } from 'react-toastify'; 

import Switch from "react-switch";
import { isEmpty } from "../../helper/helper.js"

function ProvinceForm({ props = {} }) { 


  const [appData, setAppData] = useState({ active: true }) 

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target
    setAppData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const handleOnChangeSwitch = async (c, e, id) => {
    setAppData(prevState => ({ ...prevState, [id]: c }))
  }

  const saveAction = async (e) => {
    e.preventDefault()

    let payload = {
      code: appData.code,
      name: appData.name,
      active: appData.active,
    }

    /**
     * check / validate data 
     */

    if (isEmpty(appData.code) || isEmpty(appData.name)) {
      toast.error('Code / Name is required')
    }

    if (!props.uid) {
      // New 
      await axios.post(`${window.API_HOST}/v1/province`, payload).then(async (res) => {
        setAppData(prevState => ({
          ...prevState,
          uid: res.data.uid,
          updated_at: res.data.updated_at,
          updated_by: res.data.updated_by
        }))
        props.uid = res.data.uid
        toast.success(`Success save province ${appData.name}`)
      }).catch(err => {
        toast.error(err.response.data.error)
      })
    } else {

      //Update
      await axios.put(`${window.API_HOST}/v1/province/${props.uid}`, payload).then(async (res) => {
        const resp = res.data 

        setAppData(prevState => ({
          ...prevState,
          updated_at: resp?.data.updated_at,
          updated_by: resp?.data.updated_by
        }))
        toast.success(`Success save province ${appData.name}`)
      }).catch(err => {
        toast.error(err.response.data.error)
      })

    }


  }

  const retrieveData = async () => { 

    await axios.get(`${window.API_HOST}/v1/province/${props.uid}`).then(async (res) => {
      const data = res.data.data 

        setAppData(prevState => ({
          ...prevState,
          code: data.code,
          name: data.name,
          active: data.active,
          updated_at: data.updated_at,
          updated_by: data.updated_by
        }))
        
      }).catch(err => {
        toast.error(err.response.data.error)
      })

  }
  useEffect(() => {

    //load ui data form
    async function fetchForm() {
      await axios.post(`${window.API_HOST}/ui/v1/form-shipment`)
        .then(res => {
          const data = res.data;
          // setFormData(prevState => ({
          //   ...prevState
          // }))

        }).catch(err => {

        })
    }

    if(props?.uid) {
      retrieveData()
    }

  }, []);

  return (
    <div>
      <Panel className='w-600px'>
        <PanelHeader className="bg-purple-200  p-2 p-r-0" noButton>
          <div className='row'>
            <div className='col-sm-6 fw-bolder fs-2 text-black'>{props.uid ? 'Update' : 'Create'} Province</div>
            <div className='col-sm-6 align-items-baseline text-end'>
              <div className=''>
                {(true) ? <button className="btn btn-sm btn-primary ms-3 f-s-11 text-center ml-3" onClick={saveAction}><i className="fa fa-save"></i> Save</button> : null}
                {(true) ? <button className="btn btn-sm btn-danger ms-3 f-s-11 text-center ml-3" onClick={props.cancelAction}><i className="fa fa-minus-circle"></i> Close</button> : null}
              </div>

            </div>
          </div>
        </PanelHeader>
        <PanelBody>
          <div className='row'>
            <div className='col-sm-12'>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Code</label>
                <div className="col-sm-9">
                  <div className='col-sm-4'>
                    <input type="text" name="code" value={appData.code ?? ''} onChange={handleOnChangeInputText} className="form-control form-control-sm" disabled={props.uid} />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Name</label>
                <div className="col-sm-9">
                  <input type="text" name="name" value={appData.name ?? ''} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                </div>
              </div>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Active</label>
                <div className="col-sm-9">
                  <Switch id="active" name="active" onChange={handleOnChangeSwitch} checked={appData.active ?? false} />
                </div>
              </div>
              <div className="form-group row mt-3">
                <label className="col-sm-3 col-form-label">Updated By </label>
                <div className="col-sm-9 ">
                  <div className='row'>
                    <div className='col-sm-7'>
                      <input type="text" value={appData.updated_by ?? ''} className="form-control form-control-sm" readOnly disabled />
                    </div>
                    <div className='col-sm-5'>
                      <input type="text" value={appData.updated_at ?? ''} className="form-control form-control-sm" readOnly disabled />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </PanelBody>
      </Panel> 
    </div>

  )


}

export default ProvinceForm